<template>
  <tr>
    <TableCellListbox
      :options="descOptions"
      :displayOptions="descOptions"
      v-model:selected="lineItem.description"
    >
    </TableCellListbox>
    <TableCellInput :placeHolder="'input value (number)'" :type="'number'" v-model="lineItem.value">
    </TableCellInput>
    <TableCellButton
      :name="'Delete Row'"
      :buttonClass="'delete-btn'"
      @clicked="deleteRow"
    ></TableCellButton>
  </tr>
  <!--
    <datalist id="listId">
        <option v-for="(item, index) in descOptions" :key="index" :value="item"
            :selected="lineItem.description == item">{{ item }}
        </option>
    </datalist>-->
</template>

<script setup lang="ts">
import type { LineItem } from '@/types/types'
import { TableCellListbox, TableCellInput, TableCellButton } from '@/components/table'

const props = defineProps({
  descOptions: { type: Array },
  index: { type: Number }
  //description: { type: String },
  //value: { type: String }
})

const lineItem = defineModel<LineItem>({ required: true, default: [{ description: '', value: 0 }] })

const emits = defineEmits(['delete'])

function deleteRow() {
  emits('delete', props.index)
}
</script>

<style scoped lang="css">
/*td {
    padding: 0;
    margin: 0;
}

td.delete {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

}


input {
    display: block;
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    background-color: white;
    border: 1px solid grey;
    border-radius: 0.25rem;
    font-size: 1rem;
}*/
</style>
